<template>
    <a :href="to" :class="{'link-underlined': underlined, 'icon-position-start': startWithIcon}" class="link" @click="clickHandler($event)">
        <span>
            <slot/>
        </span>
        <Icon v-if="icon !== ''" :name="icon" :class="{'arrow-down': arrowDown && icon === 'arrow', 'arrow-up': arrowUp && icon === 'arrow'}"/>
    </a>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'default'
        },
        underlined: {
            type: Boolean,
            default: false
        },
        arrowDown: {
            type: Boolean,
            default: false
        },
        arrowUp: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: ''
        },
        startWithIcon: {
            type: Boolean,
            default: false
        },
        to: {
            type: String,
            required: true
        },
        clickHandler: {
            type: Function,
            default: function() {}
        }
    }
};
</script>

<style lang="scss">
.icon {
    &.arrow-down {
        transform: rotateZ(90deg);
    }
    &.arrow-up {
        transform: rotateZ(-90deg);
    }
}
</style>
